export default __webpack_public_path__ + "static/media/profile-dd.3f2b3842.svg";